(function ($) {
  function getConfig() {
    return window.klaviyoNotifyConfig || {};
  }

  function closePanel($wrap, skipFocusTrigger) {
    var $trigger = $wrap.find('.klaviyo-notify-trigger');
    var $panel = $wrap.find('.klaviyo-notify-panel');
    $wrap.removeClass('is-open');
    $trigger.attr('aria-expanded', 'false');
    $panel.attr('hidden', true);
    if (!skipFocusTrigger && $trigger.length) {
      $trigger.focus();
    }
  }

  function openPanel($wrap) {
    var $trigger = $wrap.find('.klaviyo-notify-trigger');
    var $panel = $wrap.find('.klaviyo-notify-panel');
    $wrap.addClass('is-open');
    $trigger.attr('aria-expanded', 'true');
    $panel.removeAttr('hidden');
    $wrap.find('[name="klaviyo_notify_email"]').focus();
  }

  function syncNotifyVisibility($productForm) {
    var $wrap = $productForm.find('.klaviyo-notify-mobile');
    if (!$wrap.length) {
      return;
    }
    var $select = $productForm.find('select[name="id"]');
    if (!$select.length) {
      return;
    }
    var available = $select.find('option:selected').attr('data-available') === 'true';
    $wrap.toggleClass('is-visible', !available);
    if (available) {
      closePanel($wrap, true);
      $wrap.find('.klaviyo-notify-msg').text('').removeClass('is-error is-success');
    }
  }

  function showMsg($wrap, text, ok) {
    var $msg = $wrap.find('.klaviyo-notify-msg');
    $msg.removeClass('is-error is-success');
    $msg.addClass(ok ? 'is-success' : 'is-error');
    $msg.text(text);
  }

  $(function () {
    $('.add-to-cart-form.mobile').each(function () {
      syncNotifyVisibility($(this));
    });

    $(document).on(
      'change',
      '.add-to-cart-form.mobile select[name="id"]',
      function () {
        syncNotifyVisibility($(this).closest('form'));
      },
    );

    $(document).on(
      'click',
      '.add-to-cart-form.mobile .klaviyo-notify-trigger',
      function (e) {
        e.preventDefault();
        var $wrap = $(this).closest('.klaviyo-notify-mobile');
        if (!$wrap.hasClass('is-visible')) {
          return;
        }
        openPanel($wrap);
      },
    );

    $(document).on(
      'click',
      '.add-to-cart-form.mobile .klaviyo-notify-cancel',
      function (e) {
        e.preventDefault();
        var $wrap = $(this).closest('.klaviyo-notify-mobile');
        closePanel($wrap);
      },
    );

    $(document).on('keydown', function (e) {
      if (e.key !== 'Escape') {
        return;
      }
      $('.add-to-cart-form.mobile .klaviyo-notify-mobile.is-open').each(function () {
        closePanel($(this));
      });
    });

    $(document).on(
      'click',
      '.add-to-cart-form.mobile .klaviyo-notify-submit',
      function (e) {
        e.preventDefault();
        var cfg = getConfig();
        if (!cfg.companyId) {
          return;
        }

        var $btn = $(this);
        var $panel = $btn.closest('.klaviyo-notify-panel');
        var $wrap = $panel.closest('.klaviyo-notify-mobile');
        var $productForm = $wrap.closest('form');
        var $email = $wrap.find('[name="klaviyo_notify_email"]');
        var email = ($email.val() || '').trim();
        var vid = ($productForm.find('select[name="id"]').val() || '').trim();

        if (!email) {
          showMsg($wrap, 'Please enter your email.', false);
          $email.focus();
          return;
        }

        var variantCompositeId =
          '$shopify:::$default:::' + String(vid).replace(/\D/g, '');
        var revision =
          cfg.revision && String(cfg.revision)
            ? cfg.revision
            : '2024-06-15';

        var payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: variantCompositeId,
                },
              },
            },
          },
        };

        var url =
          'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
          encodeURIComponent(cfg.companyId);

        $btn.prop('disabled', true);
        showMsg($wrap, 'Sending…', true);

        fetch(url, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            revision: revision,
          },
          body: JSON.stringify(payload),
        })
          .then(function (res) {
            return res
              .json()
              .then(function (body) {
                return { ok: res.ok, status: res.status, body: body };
              })
              .catch(function () {
                return { ok: res.ok, status: res.status, body: null };
              });
          })
          .then(function (result) {
            $btn.prop('disabled', false);
            if (result.ok) {
              showMsg(
                $wrap,
                "You're on the list. We'll email you when it's back.",
                true,
              );
              $email.val('');
              return;
            }
            var err =
              result.body &&
              result.body.errors &&
              result.body.errors[0] &&
              result.body.errors[0].detail;
            showMsg(
              $wrap,
              err || 'Something went wrong. Please try again.',
              false,
            );
          })
          .catch(function () {
            $btn.prop('disabled', false);
            showMsg($wrap, 'Network error. Please try again.', false);
          });
      },
    );
  });
})(jQuery);
